<script setup lang="ts">
import type { TenantLandingConfig } from '~/types/types'
import { youtubeEmbed } from '~/composables/useLandingTemplate'

const props = withDefaults(defineProps<{
  landing: TenantLandingConfig
  banded?: boolean
  displayClass?: string
}>(), { banded: true, displayClass: '' })

const embedUrl = computed(() => youtubeEmbed(props.landing.video_url))
</script>

<template>
  <section
    v-if="embedUrl"
    :class="banded ? 'bg-[var(--bg2)] border-y border-[var(--border)]' : ''"
  >
    <div class="mx-auto max-w-4xl px-6 py-20 text-center">
      <h2
        v-if="landing.video_title"
        class="text-3xl tracking-tight"
        :class="displayClass"
      >
        {{ landing.video_title }}
      </h2>
      <div class="mt-6 aspect-video rounded-2xl overflow-hidden shadow-lg">
        <iframe
          :src="embedUrl"
          class="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
      <p
        v-if="landing.video_caption"
        class="mt-4 text-sm ui-text-subtle"
      >
        {{ landing.video_caption }}
      </p>
    </div>
  </section>
</template>
